import P from 'prop-types';
import { useReducer } from 'react';
import { UserContext } from './context';
import { data } from './data';
import { reducer } from './reducer';

export const UserProvider = ({ children }) => {
  const [userState, userDispatch] = useReducer(reducer, data);

  return (
    <UserContext.Provider value={{ userState, userDispatch }}>
      {children}
    </UserContext.Provider>
  );
};

UserProvider.propTypes = {
  children: P.node.isRequired,
};
